<template>

  <!-- Overlay Start -->
  <div class="overlay"></div>
  <!-- Overlay End -->

  <!-- How It Work End -->
  <div class="section section-padding margin-top-150">
    <div class="container">

      <!-- Page Content Wrapper Start -->
      <div class="page-content-wrapper padding-0">
        <div class="container-fluid custom-container">

          <!-- Message Start -->
          <div v-if='message' class="message">
            <div class="message-icon">
              <img src="/assets/images/menu-icon/icon-6.png" alt="">
            </div>
            <div class="message-content">
              <p>{{message.data}}</p>

            </div>
          </div>
          <!-- Message End -->

           
        </div>
      </div>

    </div>
  </div>
  <!-- How It Work End -->

</template>

<script>
import api from '@/services/api';
export default {
  name: 'UserVerification',
  data(){
    return {
      token: null,
      message: null
    }
  },
  mounted() {
    this.token = this.$route.params.token;
    this.verify();
  },

  methods:{
    async verify(){
      this.message = await api.get(`/user/verify/${this.token}`, {
          requiresAuth: false
      });
    }
  }
};
</script>